import Banner from '../HomePage/Banner'
import News from '../HomePage/News'
import Service from '../HomePage/Service'
import { TitleComponent } from '../TitleDocument'
import VideoLibrarySection from '../HomePage/VideoLibrarySection'
import ImageLibrarySection from '../HomePage/ImageLibrarySection'
import CompanyLinksSection from '../HomePage/CompanyLinksSection'



const Header = () => {


  return (
    <>
      <TitleComponent title='Net Portal' />
      <Banner />
      <News />
      <Service />
      <VideoLibrarySection />
      <ImageLibrarySection />
      <CompanyLinksSection />
    </>
  )
}

export default Header;
